import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTopBadge = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.4034 2.66667H18.728V0H5.35086V2.66667H2.67543C1.20394 2.66667 0 3.86667 0 5.33333V6.66667C0 10.0667 2.56841 12.84 5.87257 13.2533C6.71533 15.2533 8.52124 16.76 10.7017 17.2V21.3333H5.35086V24H18.728V21.3333H13.3771V17.2C15.5576 16.76 17.3635 15.2533 18.2063 13.2533C21.5105 12.84 24.0789 10.0667 24.0789 6.66667V5.33333C24.0789 3.86667 22.8749 2.66667 21.4034 2.66667ZM2.67543 6.66667V5.33333H5.35086V10.4267C3.79911 9.86667 2.67543 8.4 2.67543 6.66667ZM21.4034 6.66667C21.4034 8.4 20.2798 9.86667 18.728 10.4267V5.33333H21.4034V6.66667Z",
		fill: "#3FC5D6"
	})
});
export default SvgTopBadge;
